export const PERMISSIONS = {
  SYSTEM: {
    VIEW: 'system:view',
    USER: {
      VIEW: 'system:user:view',
      CREATE: 'system:user:create',
      UPDATE: 'system:user:update',
      DELETE: 'system:user:delete'
    },
    ROLE: {
      VIEW: 'system:role:view',
      CREATE: 'system:role:create',
      UPDATE: 'system:role:update',
      DELETE: 'system:role:delete'
    },
    DEPARTMENT: {
      VIEW: 'system:dept:view',
      CREATE: 'system:dept:create',
      UPDATE: 'system:dept:update',
      DELETE: 'system:dept:delete'
    },
    PERMISSION: {
      VIEW: 'system:permission:view',
      CREATE: 'system:permission:create',
      UPDATE: 'system:permission:update',
      DELETE: 'system:permission:delete'
    },
    PRODUCT: {
      VIEW: 'system:product:view',
      CREATE: 'system:product:create',
      UPDATE: 'system:product:update',
      DELETE: 'system:product:delete'
    },
    POINT_STANDARD: {
      MANAGE: 'system:point-standard:manage'
    }
  },
  MOLD: {
    LIST: {
      VIEW: 'mold:list:view',
      CREATE: 'mold:list:create',
      UPDATE: 'mold:list:update',
      DELETE: 'mold:list:delete'
    },
    DETAIL: {
      VIEW: 'mold:detail:view',
      UPDATE: 'mold:detail:update',
      DELETE: 'mold:detail:delete'
    },
    STORAGE: {
      VIEW: 'mold:storage:view',
      CREATE: 'mold:storage:create',
      QUALITY_CHECK: 'mold:storage:quality-check',
      COMPLETE: 'mold:storage:complete',
      APPROVE: 'mold:storage:approve'
    },
    BORROW: {
      MODULE: 'mold:borrow',
      VIEW: 'mold:borrow:view',
      CREATE: 'mold:borrow:create',
      APPROVE: 'mold:borrow:approve',
      RETURN: 'mold:borrow:return'
    },
    BORROW_MANAGEMENT: {
      VIEW: 'mold:borrow-management:view',
      UPDATE: 'mold:borrow-management:update'
    },
    PARTS: {
      VIEW: 'mold:parts:view',
      CREATE: 'mold:parts:create',
      UPDATE: 'mold:parts:update',
      DELETE: 'mold:parts:delete'
    }
  },
  // 加工管理权限（新增）
  PROCESSING: {
    TASK: {
      VIEW: 'processing:task:view',
      CREATE: 'processing:task:create',
      UPDATE: 'processing:task:update',
      DELETE: 'processing:task:delete',
      APPROVE: 'processing:task:approve',
      ASSIGN: 'processing:task:assign',
      START: 'processing:task:start',
      PAUSE: 'processing:task:pause',
      COMPLETE: 'processing:task:complete',
      CANCEL: 'processing:task:cancel'
    },
    APPLICATION: {
      VIEW: 'processing:application:view',
      CREATE: 'processing:application:create',
      APPROVE: 'processing:application:approve'
    }
  },
  // 调模管理权限（新增）
  DEBUGGER: {
    TASK: {
      VIEW: 'debugger:task:view',
      ASSIGN: 'debugger:task:assign'
    },
    BORROW: {
      APPROVE: 'debugger:borrow:approve'
    },
    RETURN: {
      PRE_APPROVE: 'debugger:return:pre-approve'
    },
    PARTS: {
      APPROVE: 'debugger:parts:approve'
    }
  },
  // 成型管理权限（新增）
  FORMING: {
    TASK: {
      VIEW: 'forming:task:view',
      APPROVE: 'forming:task:approve'
    },
    RECORD: {
      VIEW: 'forming:record:view',
      CREATE: 'forming:record:create',
      UPDATE: 'forming:record:update',
      DELETE: 'forming:record:delete'
    },
    BORROW: {
      APPROVE: 'forming:borrow:approve'
    },
    RETURN: {
      APPROVE: 'forming:return:approve'
    },
    PARTS: {
      APPROVE: 'forming:parts:approve'
    }
  }
} as const
